import type {
  CreateRideInput,
  MeetingPoint,
  MeetingPointInput,
  Paginated,
  Ride,
  RideDetail,
  RideListItem,
  UpdateRideInput,
} from '@ridemaadi/types';
import { apiFetch } from '../../lib/api-client';

export const ridesApi = {
  listMine: (limit = 20) => apiFetch<Paginated<RideListItem>>(`/rides?limit=${limit}`),
  listPublic: (limit = 20) => apiFetch<Paginated<RideListItem>>(`/rides/public?limit=${limit}`),
  get: (id: string) => apiFetch<RideDetail>(`/rides/${id}`),
  getBySlug: (slug: string) => apiFetch<RideDetail>(`/rides/slug/${slug}`),
  create: (input: CreateRideInput) => apiFetch<Ride>('/rides', { method: 'POST', body: input }),
  update: (id: string, input: UpdateRideInput) =>
    apiFetch<Ride>(`/rides/${id}`, { method: 'PATCH', body: input }),
  remove: (id: string) => apiFetch<void>(`/rides/${id}`, { method: 'DELETE' }),
  addMeetingPoint: (id: string, input: MeetingPointInput) =>
    apiFetch<MeetingPoint>(`/rides/${id}/meeting-points`, { method: 'POST', body: input }),
  updateMeetingPoint: (id: string, pointId: string, input: MeetingPointInput) =>
    apiFetch<MeetingPoint>(`/rides/${id}/meeting-points/${pointId}`, { method: 'PATCH', body: input }),
  removeMeetingPoint: (id: string, pointId: string) =>
    apiFetch<void>(`/rides/${id}/meeting-points/${pointId}`, { method: 'DELETE' }),
  reorderMeetingPoints: (id: string, orderedIds: string[]) =>
    apiFetch<MeetingPoint[]>(`/rides/${id}/meeting-points/reorder`, {
      method: 'PUT',
      body: { orderedIds },
    }),
};
